import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingStateProps {
  size?: number;
  message?: string;
  minHeight?: string | number;
}

/**
 * A reusable component for displaying a loading spinner
 */
const LoadingState: React.FC<LoadingStateProps> = ({
  size = 40,
  message = 'Loading...',
  minHeight = '50vh'
}) => {
  return (
    <Box 
      display="flex" 
      flexDirection="column"
      justifyContent="center" 
      alignItems="center" 
      minHeight={minHeight}
      gap={2}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body1" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingState;
